import React, { useState } from "react";
import Sidebar from "../../Layout/Sidebar";
import AdminSidebar from "../../Layout/AdminSidebar";
import Navbar from "../../Layout/Navbar";
import SalesOrdersTable from "./SalesOrdersTable";
import Pagination from "./Pagination";

const SalesOrdersPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // Simulating a user role. In a real scenario, you"d fetch this from your authentication system or state
  const userRole = localStorage.getItem("role"); // This can be "admin" or 'user', for example

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <div className="flex flex-1 w-full">
        {/* Conditionally render Sidebar or AdminSidebar based on the user"s role */}
        {userRole === "admin" ? (
          <AdminSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        ) : (
          <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        )}

        {/* Main content area */}
        <div
          className={`flex-1 p-2 transition-all overflow-hidden duration-300 ease-in-out ${
            isSidebarOpen ? "md:ml-52 ml-0" : "ml-0"
          }`}
        >
          {/* Navbar */}
          <Navbar toggleSidebar={toggleSidebar} />
          {/* <br /> */}

          {/* Page content */}
          <div className="content flex-1 max-w-full min-h-screen">
            <SalesOrdersTable />
          </div>

          {/* Responsive Footer */}
          <footer className="bg-gray-800 text-white text-center sm:text-right p-2 mt-4 shrink-0 w-full rounded-md">
            <p className="text-sm">
              Designed with ❤️ and crafted with care by Team{" "}
              <a
                href="https://www.youtube.com/@SHALENDERSINGH"
                target="_blank"
                rel="noopener noreferrer"
                className="text-yellow-500 font-bold block sm:inline hover:text-yellow-600"
              >
                SMART ITBOX
              </a>
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default SalesOrdersPage;
